import React from 'react';
import Browser from '../common/Browser';
import GenreTile from './GenreTile';
import { Slide } from 'pure-react-carousel';
import { inject, observer } from 'mobx-react';
import { isMobile, isMobileHorizontal, isTablet, isDesktop, isBigDesktop } from '../../helpers/rwd.js'

@inject('homeStore')
@observer
class HomeGenresBrowser extends Browser {
  get genres() { return this.props.homeStore.userGenres }

  get totalEntries() { return this.genres.length }

  get entries() { return this.genres.length }

  get hasOverflow() { return this.totalEntries > 4 }

  get showCounter() { return false }

  calculateVisibleSlides() {
    if (isMobileHorizontal()) {
      return 2
    } else if (isMobile()) {
      return 1
    } else if (isTablet()) {
      return 3
    } else if (isBigDesktop()) {
      return 5
    } else {
      return window.innerWidth / 384
    }
  }

  renderProducts() {
    return this.genres.map((genre, idx) =>
     <Slide key={genre.id} className='slide ml-2.5' index={idx}>
       <GenreTile genre={genre} index={idx} />
     </Slide>
   )
  }
}

export default HomeGenresBrowser
